module.exports = __webpack_public_path__ + "static/img/tripleberrybublyburst_th.fdb0755.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mixology/cans/tripleberrybublyburst_th.png
// module id = z1nP
// module chunks = 0